import { Layout, Menu } from 'antd'
import { t } from 'i18next'
import React, { useContext, useEffect, useState } from 'react'
import { Link, Outlet, useParams } from 'react-router-dom'
import { Color } from '../../Common/Color'
import BoxContext from './BoxContext'

const { Header, Content } = Layout

const items = (id, hasSpecialists) => {
  const result = [
    {
      key: `/admin/boxes/${id}/calendar`, label: (<Link to={`/admin/boxes/${id}/calendar`}>{t('Admin.Box.menu.calendar')}</Link>)
    },
    {
      key: `/admin/boxes/${id}/info`, label: (<Link to={`/admin/boxes/${id}/info`}>{t('Admin.Box.menu.info')}</Link>)
    },
    {
      key: `/admin/boxes/${id}/cleaning`, label: (<Link to={`/admin/boxes/${id}/cleaning`}>{t('Admin.Box.menu.cleaning')}</Link>)
    },
    {
      key: `/admin/boxes/${id}/opening`, label: (<Link to={`/admin/boxes/${id}/opening`}>{t('Admin.Box.menu.opening')}</Link>)
    },
    {
      key: `/admin/boxes/${id}/logs`, label: (<Link to={`/admin/boxes/${id}/logs`}>{t('Admin.Box.menu.logs')}</Link>)
    },
    {
      key: `/admin/boxes/${id}/cluster`, label: (<Link to={`/admin/boxes/${id}/cluster`}>{t('Admin.Box.menu.cluster')}</Link>)
    }]
  if (hasSpecialists) {
    result.push({
      key: `/admin/boxes/${id}/specialists`, label: (<Link to={`/admin/boxes/${id}/specialists`}>{t('Admin.Box.menu.specialists')}</Link>)
    })
  }
  return result
}

export default function BoxMenuLayout ({ children }) {
  const { id } = useParams()
  const { box } = useContext(BoxContext)
  const [current, setCurrent] = useState(location.pathname)
  const [hasSpecialists, setHasSpecialists] = useState(false)

  useEffect(() => {
    setHasSpecialists(box?.teleconsulting_company_name === 'Tessan')
  }, [box])

  return (
    <>
      <Layout style={{ padding: '1em 0', color: Color.dark_blue, fontSize: '24px' }}>
        {box?.name}
      </Layout>
      <Header style={{ padding: 0, backgroundColor: Color.white, color: Color.dark_blue }}>
        <Menu style={{ float: 'left', backgroundColor: Color.white, color: Color.dark_blue, width: '100%' }}
          onClick={(e) => setCurrent(e.key)}
          selectedKeys={[current]}
          mode='horizontal'
          items={items(id, hasSpecialists)} />
      </Header>
      <Content>
        {children || <Outlet />}
      </Content>
    </>
  )
}
